//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  created () {
    document.title = '提交详情'
  },
  mounted () {
    var _this = this
    if (this.$store.state.app.innerCode === '148198068433580000') {
      var utmSource = _this.$route.query.utm_source
      if (!utmSource || utmSource === 'wechat' || utmSource === 'wx') {
        utmSource = 'wechat'
      }
      let orderQuerenURL = '/api/hqdqx/orderQueren/'
      if (this.h5) {
        orderQuerenURL = '/api/channel/hqdqx/orderQueren/'
      }
      this.$http.get(orderQuerenURL + this.$store.state.app.innerCode + '/' + this.$store.state.app.productCode + '/' + this.$store.state.order.unionCode).then(response => {
        window._hmt.push(['_trackOrder', {
          'orderId': response.data.busOrder.orderCode,
          'orderTotal': response.data.underwritingInfoList[0].premium / 100,
          'item': [
            {
              'skuId': _this.$store.state.app.productCode,
              'skuName': response.data.busProductRelation.productName,
              'category': utmSource,
              'Price': response.data.underwritingInfoList[0].premium / 100,
              'Quantity': 1
            }
          ]}
        ])
      })
    }
    this.$http.get('https://m.wkbins.com/explosions/static/common/js/tongji.txt?where=result&productCode=' + this.$store.state.app.productCode + '&innerCode=' + this.$store.state.app.innerCode + '&utm_source=' + (this.$route.query.utm_source || '')).then(response => {
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/Resultfit.vue